<template>
  <div class="app-container courseware-detail">
    <basic-container>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件名称:</el-col>
        <el-col :span="16">{{ detail.name }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件名称（英文）:</el-col>
        <el-col :span="16">{{ detail.nameEn }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件描述:</el-col>
        <el-col :span="16">{{ detail.description ? detail.description : "--" }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件描述（英文）:</el-col>
        <el-col :span="16">{{ detail.descriptionEn ? detail.descriptionEn : "--" }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件类型:</el-col>
        <el-col :span="16">{{ getType(detail.type) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件分组:</el-col>
        <el-col :span="16">{{ formatCourseGroup(coursewareGroups, detail.coursewareGroupId) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件文件:</el-col>
        <el-col :span="16">
          <a class="courseware-detail-courseware-url" v-if="COURSEWARE_FILE_TYPE_ENUM.PDF.value===detail.type" :href="detail.coursewareUrl" target="_blank">PDF文件</a>
          <div class="courseware-content-video" v-if="COURSEWARE_FILE_TYPE_ENUM.VIDEO.value===detail.type">
            <img :src="detail.coverUrl" @click="viewVideo(detail.coursewareUrl)">
            <i class="icon-content-play"></i>
          </div>
        </el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件文件（英文）:</el-col>
        <el-col :span="16">
          <a class="courseware-detail-courseware-url" v-if="COURSEWARE_FILE_TYPE_ENUM.PDF.value===detail.type" :href="detail.coursewareUrlEn" target="_blank">PDF文件</a>
          <div class="courseware-content-video" v-if="COURSEWARE_FILE_TYPE_ENUM.VIDEO.value===detail.type">
            <img :src="detail.coverUrlEn" @click="viewVideo(detail.coursewareUrlEn)">
            <i class="icon-content-play"></i>
          </div>
        </el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件长度（英文）:</el-col>
        <el-col :span="16">{{ formatCoursewareLength(detail.type, detail.coursewareLengthEn) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件长度:</el-col>
        <el-col :span="16">{{ formatCoursewareLength(detail.type, detail.coursewareLength) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件建议学习时长:</el-col>
        <el-col :span="16">{{ formatTime(detail.coursewareTime) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">课件建议学习时长（英文）:</el-col>
        <el-col :span="16">{{ formatTime(detail.coursewareTimeEn) }}</el-col>
      </el-row>
      <el-row class="courseware-detail-item">
        <el-col :span="3">创建时间:</el-col>
        <el-col :span="16">{{ detail.insertedTime }}</el-col>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { getCoursewareById } from '@/api/app/course';
import { coursewareFileTypeEnums as COURSEWARE_FILE_TYPE_ENUM } from '@/const/crud/app/course';
import { formatCourseGroup, formatCoursewareLength, formatTime } from './util/index';
import { coursewareTypeOptions } from '@/const/crud/app/course';
import { fetchCoursewareGroupList } from '@/api/app/course';
import { requestWrapper } from '@/util/util';

export default {
  data() {
    return {
      coursewareTypeOptions,
      COURSEWARE_FILE_TYPE_ENUM,
      detail: {},
      coursewareGroups: [],
    }
  },
  async created () {
    const res = await requestWrapper(fetchCoursewareGroupList);
    if (!res.ok) {
      this.$message.error('获取课件分组失败');
    } else {
      this.coursewareGroups = res.data;
    }
    this.id = this.$route.params.id;
    this.getDetail();
  },
  methods:{
    formatCourseGroup,
    formatCoursewareLength,
    formatTime,
    getType(value) {
      return this.coursewareTypeOptions.find(item => item.value === value ).label;
    },
    getDetail() {
      getCoursewareById(this.id).then(res => {
        this.detail = res.data.data;
      }).catch(error => {
        this.$message({
          message: '获取问卷详情失败',
          type: 'error',
        });
      })
    },
    viewVideo(url) {
      window.open(url);
    },
  }
}
</script>

<style lang="scss" scoped>
.courseware-detail {
  &-item {
    font-size: 16px;
    margin: 10px 0;
  }
  &-courseware-url {
    cursor: pointer;
    color: #409EFF;
  }
}
.courseware-content-video {
  display: flex;
  width: fit-content;
  cursor: pointer;
  img {
    width: 356px;
    height: 200px;
    object-fit: cover;
    max-width: 100%;
  }
}
</style>
